module.exports = __webpack_public_path__ + "static/media/placeholder-image.b6579ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-image.png
// module id = 138
// module chunks = 0